import i18n from '@/locales'
import {
  getTimeTableColumn,
  getEnabledTableColumn,
  getNameDescriptionTableColumn,
  getProjectTableColumn,
  getPublicScopeTableColumn,
} from '@/utils/common/tableColumn'
import { getFieldValueTypeText, getFieldConfigText } from '../constants'

export default {
  data () {
    return {
      columns: [
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          field: 'name',
          hideField: true,
          edit: true,
          editDesc: true,
          formRules: [{ required: true, message: i18n.t('common.tips.input', [i18n.t('table.title.name')]) }],
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
            )
          },
        }),
        {
          field: 'attributes',
          title: i18n.t('report.fields'),
          slots: {
            default: ({ row }) => {
              const columns = [
                {
                  field: 'name',
                  title: i18n.t('common_186'),
                  formatter: ({ row }) => {
                    return `${row.name}${row.unit ? `(${row.unit})` : ''}` || '-'
                  },
                },
                {
                  field: 'value_type',
                  title: i18n.t('report.field_type'),
                  formatter: ({ row }) => {
                    return getFieldValueTypeText(row)
                  },
                },
                {
                  field: 'config',
                  title: i18n.t('report.field_setting'),
                  formatter: ({ row }) => {
                    return getFieldConfigText(row)
                  },
                },
              ]
              const data = row.attributes || []
              return [<list-body-cell-popover text={this.$t('common_701', [(row.attributes || []).length])} min-width="800px">
                <vxe-grid size="mini" border showOverflow={false} row-config={{ isHover: true }} column-config={{ resizable: false }} columns={columns} data={data} />
              </list-body-cell-popover>]
            },
          },
          formatter: ({ row }) => {
            return (row.attributes || []).length
          },
        },
        {
          field: 'type',
          title: this.$t('report.category'),
          formatter: ({ row }) => {
            return row.type || '-'
          },
        },
        getProjectTableColumn(),
        getPublicScopeTableColumn({
          vm: this,
          resource: 'ext_resource_types',
        }),
        getEnabledTableColumn(),
        getTimeTableColumn(),
      ],
    }
  },
  methods: {
  },
}
